<div class="container">
  <div class="containerColumn">
    <img class="confirmationImageWrapper" [src]="labels.CONFIRMATION_HERO_IMAGE">
    <div class="confirmationNoteContainer">
      <mat-card class="confirmationNote">
        <h4>
          {{ labels.CONFIRMATION_YOUR_CARD }} <span class="bold"> {{ cardNo }} </span>
          {{ labels.CONFITMATION_ACTIVATED }}
        </h4>
      </mat-card>
    </div>

    <p class="confirmationDescription">
      {{ labels.CONFIRMATION_DESCRIPTION }}
    </p>

    <div class="articleSection">
      <div class="articleContainer" *ngFor="let article of labels.CONFIRMATION_ARTICLES">
        <mat-card class="confirmationArticles">
          <div><img [src]="article.icon"/></div>
          <mat-card-content>
            <span class="bold"><h2>{{ article.title }}</h2></span>
            <p>{{ article.description }}</p>
            <mat-divider></mat-divider>
          </mat-card-content>

          <mat-card-actions>
            <a *ngFor="let link of article.links" color="accent" [href]="link.link" mat-raised-button target="_blank"
               class="btn-primary">{{ link.text }}</a>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
  </div>
</div>
